

import React, { useEffect, useState } from 'react'
import { db, firebaseAuth, storage } from "../utils/firebase-config";
import { createUserWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import HomeLf from './HomeLf';
import logo from '../assets/version2/logo.png';
//import Header from './Header';

// REGISTER MASTER

function Adicionar(parametros) {

    const navigate = useNavigate();

  


    const [mecanica, setMecanica] = useState(false);
    const [eletrica, setEletrica] = useState(false);
    const [eletronica, setEletronica] = useState(false);
    const [construcao, setConstrucao] = useState(false);
    const [construcaoCivil, setConstrucaoCivil] = useState(false);
    const [terceirizado, setTerceirizado] = useState(false);
    const [proprio, setProprio] = useState(false);
    const [conjunto, setConjunto] = useState(false);
    const [projetoNome, setProjetoNome] = useState('');
    const [comentariosIniciais, setComentariosIniciais] = useState('');
    const [descricao, setDescricao] = useState('');
    const [current, setCurrent] = useState('');

    function master(params) {

        

        var objMaster = [];
        onAuthStateChanged(firebaseAuth, async (currentUser) => {
            if (currentUser) {
           
                setCurrent(current);
            };
          });
        
        
        }













    async function finishMaster(params) {

        var disciplinasObj = [];
     
        for (let i = 0; i < document.querySelectorAll('.disciplinas').length; i++) {
            disciplinasObj.push(document.querySelectorAll('.disciplinas')[i].value);
            
        }

        var colaboradoresMaster = [];
        for (let i = 0; i < document.querySelectorAll('.dadoscolaboradores').length; i++) {
            colaboradoresMaster.push(`${document.querySelectorAll('.dadoscolaboradores')[i].querySelector('input').value} ###master ${document.querySelectorAll('.dadoscolaboradores')[i].querySelectorAll('select')[0].value}  ###master ${document.querySelectorAll('.dadoscolaboradores')[i].querySelectorAll('select')[1].value}`)
        }

        var colaboradoresId = [];
        for (let i = 0; i < document.querySelectorAll('.dadoscolaboradores').length; i++) {
            colaboradoresId.push(document.querySelectorAll('.dadoscolaboradores')[i].querySelector('input').value);
        }


        var nomeDaOrdem = 'ordem001';

        // `mensagem ######disciplinas/eletrica/hidraulica ######quemmandou/${quemMandou}`] 
        var objetoMsgs = {
           // [nomeDaOrdem]: { nome: '', status: '', prioridade: '', disciplinas: [], mensagens: []},
         
        }
          
            var randomName = Math.random();
            randomName = String(randomName);
            randomName = randomName.replace('0.', '');
       

             const dataAtual2 = new Date();        
            var dataAtual = dataAtual2.toISOString();


        await setDoc(doc(db, 'projetos', randomName), {
            
      
                nomeDoProjeto: projetoNome,
                idProjeto: randomName,
                disciplinas: disciplinasObj,
                colaboradores: colaboradoresMaster,
                mecanica: mecanica,
                eletrica: eletrica,
                emailsParticipantes: colaboradoresId,
                criador: firebaseAuth.currentUser.email,
                eletronica: eletronica,
                construcao: construcao,
                construcaoCivil: construcaoCivil,
                conjunto: conjunto,
                dataDeCriacao: dataAtual,
                ordens: [],
                proprio: proprio,
                terceirizado: terceirizado,
                descricao: descricao,
                comentariosIniciais: comentariosIniciais,
                urn: ''

            

          });
         
          
          setTimeout(() => {
            navigate('/main');
          }, 1000);

    }

 










        

    


    useEffect(()=> {
        master();

    },[])


  return (
  
<>








<div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
display: 'flex', justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div style={{cursor: 'pointer'}}>    <i class="bi bi-x" style={{fontSize: '25px'}}/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Título do Projeto</div>
<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira o título do projeto"
  onChange={(e) => setProjetoNome(e.target.value)  }
></input>
</div>


<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Descrição do Projeto</div>
<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira informações do projeto"
  onChange={(e) => setDescricao(e.target.value)  }
></input>
</div>




<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>informações do Projeto</div>
<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira a descrição do projeto"
  onChange={(e) => setComentariosIniciais(e.target.value)  }
></input>
</div>












<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div style={{width: '150px', height: '35px', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
        onClick={()=> finishMaster()}
        >Criar Projeto </div>
</div>

</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>




















































































  

  
   

   


 



        </>
  );
}

export default Adicionar;







